interface HandleBackFunction {
  (): boolean | undefined | void;
}

interface UseHardwareBackPressFunction {
  (handleBack: HandleBackFunction): void;
}

const useHardwareBackPress: UseHardwareBackPressFunction = () => {};

export {useHardwareBackPress};
